import React from 'react';
import { Box, Typography, Stack, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { formatDateTime } from '../../../utils/format';

function NotificationCard({ i, handleClear }) {
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 2, pt: 0.2, pl: 2, pb: 1, pr: 1, mb: 1, mx: 2 }}>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} mb={0.5}>
        <Typography sx={{ color: 'text.secondary', fontSize: 15, fontWeight: 600 }}> {i?.title} </Typography>
        <Stack direction={"row"} alignItems={"center"} justifyContent={"end"} gap={2} width={"40%"}>
          <Typography sx={{ color: 'blue', fontSize: 12, fontWeight: 500 }}>{formatDateTime(i?.cAt)}</Typography>
          <IconButton sx={{ color: "red" }} onClick={() => handleClear(i?.id)}>
            <CancelIcon />
          </IconButton>
        </Stack>
      </Stack>
      <Stack>
        <Typography sx={{ fontSize: 13, }}>{i?.content}</Typography>
      </Stack>
    </Box>
  );
}

export default NotificationCard;